export interface settingData {
  multilingual: boolean;
  calender: Calender;
}

export enum Calender {
  English = 1,
  Persian = 2,
}
